<template>
  <div id="page-project">
    <div class="title-page">
      <textCode text="h1" />
      <header-text text="Certificate & License" close="true"></header-text>
    </div>

    <div class="row">
      <article v-for="(item, index) in reports" :key="index" class="column">
        <div>
          <div class="card">
            <img
              :src="require(`@/assets/images/projects/${item.image}`)"
              class="project-img"
              alt=""
            />

            <div class="action">
              <a target="_blank" :href="item.link"> See More </a>
            </div>

            <img
              src="../assets/images/projects/kabby.png"
              alt="khaby"
              class="khaby"
            />
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProjectPage",
  components: {
    HeaderText: () => import("@/components/atoms/text-header-title.vue"),
    TextCode: () => import("@/components/atoms/text-code.vue"),
  },
  data() {
    return {};
  },
  computed: {
    reports() {
      return this.$store.state.Project.reports;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/project.scss";
</style>